export default __webpack_public_path__ + "static/media/logo-x-twitter.6a5f093d.svg";